<template>
  <v-card
    v-if="sortedCalls.length"
    outlined
    rounded
    class="lead-calls-tags pa-4"
  >
    <span class="overline grey--text text--darken-1">Descarte por tag</span>
    <div class="d-flex justify-space-between align-end">
      <span class="text-subtitle-1 font-weight-bold black--text"
        >No contesta</span
      >
      <span class="discard-counter grey--text text--darken-1">
        <strong class="black--text">{{ noResponseCount }}</strong> /
        {{ discardLimit }}
      </span>
    </div>

    <v-divider class="my-4" />

    <v-card outlined rounded class="calls-card">
      <div class="d-flex justify-space-between align-center pa-4 pb-0">
        <span class="overline grey--text text--darken-1"
          >Llamadas Ringover</span
        >
        <v-chip
          v-if="hasAssignedBroker"
          small
          outlined
          class="font-weight-medium"
        >
          Ciclo actual
        </v-chip>
      </div>
      <div v-if="hasAssignedBroker" class="px-4 pt-1">
        <span class="font-weight-bold black--text">{{
          displayBrokerName
        }}</span>
      </div>

      <v-divider class="mt-3" />

      <div class="calls-list" :class="{ 'calls-list--scroll': showAllCalls }">
        <div
          v-for="(call, index) in visibleCalls"
          :key="call._id || call.call_id || index"
          class="call-tags-item px-4 py-3"
        >
          <v-divider v-if="index > 0" class="mb-3" />
          <div class="d-flex justify-space-between align-center">
            <span class="caption grey--text text--darken-1">
              <strong class="black--text">{{ index + 1 }}.</strong>
              {{ formatDate(call.created_at) }}
            </span>
            <span v-if="call.call_id" class="caption grey--text text--darken-1">
              call_id: {{ call.call_id }}
            </span>
          </div>
          <div class="mt-2">
            <v-chip
              v-for="(tag, tagIndex) in call.tags"
              :key="`${tag.tag_id}-${tagIndex}`"
              small
              outlined
              class="mr-1 mb-1"
            >
              <span
                class="tag-color-dot mr-1"
                :style="{
                  backgroundColor: tag.color ? `#${tag.color}` : '#000'
                }"
              ></span>
              {{ tag.name }}
            </v-chip>
            <span
              v-if="!call.tags || !call.tags.length"
              class="caption grey--text"
            >
              Sin etiquetas
            </span>
          </div>
        </div>
      </div>

      <template v-if="sortedCalls.length > 1">
        <v-divider />
        <div class="text-center py-1">
          <v-btn
            text
            small
            color="primary"
            @click="showAllCalls = !showAllCalls"
          >
            {{ showAllCalls ? "Ver menos" : "Ver más" }}
          </v-btn>
        </div>
      </template>
    </v-card>
  </v-card>
</template>

<script>
import moment from "moment";
moment.locale("es");

const DISCARD_LIMIT = 21;

export default {
  name: "LeadCallsTags",
  props: {
    calls: {
      type: Array,
      default: () => []
    },
    noResponseCount: {
      type: Number,
      default: null
    },
    brokerName: {
      type: String,
      default: ""
    },
    hasAssignedBroker: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAllCalls: false,
      discardLimit: DISCARD_LIMIT
    };
  },
  computed: {
    sortedCalls() {
      return [...this.calls].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    },
    visibleCalls() {
      return this.showAllCalls
        ? this.sortedCalls
        : this.sortedCalls.slice(0, 1);
    },
    displayBrokerName() {
      return this.brokerName || "Desconocido";
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD MMM YYYY");
    }
  }
};
</script>

<style scoped>
.lead-calls-tags {
  margin-top: 1rem;
}

.discard-counter {
  font-size: 1.1rem;
}

.calls-card {
  background-color: #fafafa;
}

.calls-list--scroll {
  max-height: 320px;
  overflow-y: auto;
}

.tag-color-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
</style>
